'use client';

import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["align"],
  _excluded2 = ["align", "colorSet", "className", "contextual", "children", "onClose", "renderIcon", "renderMessage", "renderCloseButton", "iconAriaLabel", "closeButtonAriaLabel"];
import React from 'react';
import cx from 'classnames';
import { ENCORE_DATA_IDS } from "../../dataEncoreIds.mjs";
import { addColorSet, textClass } from "../../styles/index.mjs";
import { CloseButton } from "./CloseButton.mjs";
import { Icon } from "./Icon.mjs";
import { Message } from "./Message.mjs";
import { Wrapper } from "./Wrapper.mjs";
var defaultIconRender = function defaultIconRender(props) {
  return /*#__PURE__*/React.createElement(Icon, props);
};
var defaultMessageRender = function defaultMessageRender(_ref) {
  var align = _ref.align,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(Message, Object.assign({
    $align: align
  }, props));
};
var defaultCloseButtonRender = function defaultCloseButtonRender(props) {
  return /*#__PURE__*/React.createElement(CloseButton, props);
};
var getIconAriaLabel = function getIconAriaLabel(bannerColorSet) {
  switch (bannerColorSet) {
    case 'negative':
      return 'Error:';
    case 'warning':
      return 'Warning:';
    case 'positive':
      return 'Success:';
    case 'announcement':
      return 'Announcement:';
    default:
      return 'Info:';
  }
};
var BannerComponent = /*#__PURE__*/React.forwardRef(function BannerComponent(_ref2, ref) {
  var align = _ref2.align,
    colorSet = _ref2.colorSet,
    className = _ref2.className,
    _ref2$contextual = _ref2.contextual,
    contextual = _ref2$contextual === void 0 ? false : _ref2$contextual,
    children = _ref2.children,
    onClose = _ref2.onClose,
    _ref2$renderIcon = _ref2.renderIcon,
    renderIcon = _ref2$renderIcon === void 0 ? defaultIconRender : _ref2$renderIcon,
    _ref2$renderMessage = _ref2.renderMessage,
    renderMessage = _ref2$renderMessage === void 0 ? defaultMessageRender : _ref2$renderMessage,
    _ref2$renderCloseButt = _ref2.renderCloseButton,
    renderCloseButton = _ref2$renderCloseButt === void 0 ? defaultCloseButtonRender : _ref2$renderCloseButt,
    _ref2$iconAriaLabel = _ref2.iconAriaLabel,
    iconAriaLabel = _ref2$iconAriaLabel === void 0 ? getIconAriaLabel(colorSet) : _ref2$iconAriaLabel,
    _ref2$closeButtonAria = _ref2.closeButtonAriaLabel,
    closeButtonAriaLabel = _ref2$closeButtonAria === void 0 ? 'Close' : _ref2$closeButtonAria,
    props = _objectWithoutProperties(_ref2, _excluded2);
  return /*#__PURE__*/React.createElement(Wrapper, Object.assign({
    "data-encore-id": ENCORE_DATA_IDS.Banner,
    className: cx(addColorSet(colorSet), textClass('bodySmall'), className),
    ref: ref,
    $colorSet: colorSet,
    $align: align,
    $contextual: contextual,
    $showClose: onClose ? true : undefined
  }, props), renderIcon({
    colorSet: colorSet,
    iconAriaLabel: iconAriaLabel
  }), renderMessage({
    children: children,
    align: align
  }), onClose && renderCloseButton({
    onClose: onClose,
    closeButtonAriaLabel: closeButtonAriaLabel
  }));
});
var bannerHelpers = {
  /**
   * @deprecated
   */
  Icon: Icon,
  /**
   * @deprecated
   */
  Message: Message,
  /**
   * @deprecated
   */
  CloseButton: CloseButton
};

/**
 * Banners bring attention to important information, errors or warnings. They use a combination of icons, copy, and color to indicate the type of message, and some variants are dismissible.
 *
 * [Storybook](https://encore-web.spotify.net/?path=/docs/components-backdrop--docs) |
 * [Encore site](https://encore.spotify.net/web/components/banner) |
 * [Github](https://ghe.spotify.net/encore/web/tree/master/src/core/components/Banner) |
 * [Figma](https://www.figma.com/design/bnQXqGkLeiTlbk8JXGDcsX/%E2%9A%99%EF%B8%8F-%E2%80%8A%E2%80%8BEncore-Web-Components?node-id=0-1548)
 */
export var Banner = Object.assign(BannerComponent, bannerHelpers);